export default "__VITE_ASSET__jGC51__P__"